import { SxProps, Theme } from '@mui/material';

type TStyles = {
  modal: SxProps<Theme>;
  backdrop: SxProps<Theme>;
  paper: (theme: Theme) => SxProps<Theme>;
  closeButton: SxProps<Theme>;
  content: SxProps<Theme>;
  text: SxProps<Theme>;
  actions: SxProps<Theme>;
};

export const styles: TStyles = {
  modal: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    border: `1px solid ${theme.palette.border.subtle}`,
    m: 0,
    p: 0,
    zIndex: 2000,
  }),
  backdrop: {
    backgroundColor: 'transparent',
    backdropFilter: 'blur(5px)',
    WebkitBackdropFilter: 'blur(5px)',
  },
  paper: (theme: Theme) => ({
    width: '400px',
    maxWidth: '90%',
    maxHeight: '90vh',
    m: '30px',
    p: '30px',
    boxSizing: 'border-box',
    border: '1px solid',
    borderColor: theme.palette.border.subtle,
    borderRadius: '18px',
    boxShadow: theme.palette.shadow.modal,
    backgroundColor: theme.palette.common.white,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'auto',
    outline: 'none',
    color: theme.palette.text.primary,
  }),
  closeButton: (theme: Theme) => ({
    position: 'absolute',
    top: '10px',
    right: '10px',
    width: '24px',
    height: '24px',
    minWidth: '24px',
    p: 0,
    color: theme.palette.common.black,
    cursor: 'pointer',
    '@media (max-width: 600px)': {
      width: '20px',
      height: '20px',
      minWidth: '20px',
    },
  }),
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  text: {
    width: '100%',
    mt: 2,
    mb: 0,
    fontFamily: 'Nunito Sans',
    fontWeight: 500,
    fontSize: '14px',
    textAlign: 'center',
    letterSpacing: 0,
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    mt: '15px',
  },
};
